import {AbilityBuilder, createMongoAbility} from "@casl/ability";
import {AbilityStore} from "./store/store";
import {DefaultAbility} from "./store/DefaultAbility";

function subjectName(item) {
    if (!item || typeof item === 'string') {
        return item
    }

    return item._subjectName
}

export const ActionKeys = {
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
    READ: "read",
    SETTING: "setting",
    ACCESS: "access",
    RECALL: "recall",
}

export const SubjectName = {
    timeKeeping: "timeKeeping",
    salaryTable: "salaryTable",
    tnp: "tnp"
}

export const CreateValue = {
    TRUE: "true",
    FALSE: "false"
}

const conditionsMatcher = matchConditions => matchConditions;

export default (workspace) => {
    const abilityBuilder = new AbilityBuilder(createMongoAbility);
    const {can: allow, cannot: notAllow, rules} = abilityBuilder

    if (workspace) {
        const isAdmin = workspace?.isAdministrator
        const isSystem = workspace?.isSystemManager
        const specialPermission = {isAdmin, isSystem}
        const isAccess = workspace?.enable

        allow(ActionKeys.ACCESS, workspace.key, () => isAccess)
        allow(ActionKeys.SETTING, workspace.key, () => isAdmin || isSystem)

        workspace?.subWorkspaces?.forEach(subWorkspace => {

            const key = subWorkspace.key
            AbilityStore[key] ?
                AbilityStore[key](abilityBuilder, specialPermission, subWorkspace) :
                DefaultAbility(abilityBuilder, specialPermission, subWorkspace)
        })
    }

    return createMongoAbility(rules, {detectSubjectType: subjectName, conditionsMatcher})
}